<template>
  <div class="boxed-text-container-style">
    <ul  class="editor-design">
      <li>
        アウトライン
      </li>
      <!-- 背景色 -->
      <li class="flex-box">
        <select-color
          :type="'part'"
          :target="'background'"
          :selector="null"
          :value="value ? value['background'] : null"
          @updateStyles="updateStyles($event, 'background')"
        />
        <!-- 罫線 -->
        <!-- 4方向に同じ値が設定されるので、代表としてborder-topを渡す -->
        <select-border
          :type="'part'"
          :target="targetProp('border')"
          :value="value ? value['border'] || value['border-top'] : null"
          @updateStyles="updateStyles($event, 'border')"
        />
      </li>
      <!-- 余白（内側） -->
      <li class="flex-box">
        <slider
          :prop="'inner-padding'"
          :value="value ? value['inner-padding'] : null"
          @updateStyles="updateStyles($event, 'inner-padding')"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectBorder from '@/components/Content/Palette/CommonLayouts/EditStyleBorder'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  props: [
    'value',
    'sectionId',
    'partsContainerId',
    'partId',
    'partsContainerType',
  ],
  components: {
    SelectColor,
    SelectBorder,
    Slider,
  },
  computed: {
    // パーツコンテナのタイプ + スタイル名を、変更対象項目とする
    // → 画像カードパーツにて、1画面に同じ項目が2つ表示される場合がある(画像の罫線と、テキストボックスの罫線)
    // →→ どのパーツの罫線を変更したいのか判別するために、テキストボックス側の対象項目名は [パーツコンテナ名 + アンダーバー + 'border'] とする
    targetProp () {
      return function (target) {
        if (!this.partsContainerType) return null
        return this.partsContainerType.toLowerCase() + '_' + target
      }
    },
  },
  methods: {
    updateStyles (styles, prop) {
      if (!this.partsContainerType) return null
      if (this.partsContainerType === 'ImageCard' && (prop === 'border' || prop === 'background')) {
        // 画像カードの[罫線][背景色]を更新した場合：スタイルはパーツコンテナに持っているため、パーツコンテナを更新
        // パーツコンテナには border を1つの項目に四方向まとめて持っているので、borderを更新した場合は代表で最初の値を更新処理に送る
        const updateStyles = prop === 'border' ? [{ prop: 'border', value: styles[0].value }] : styles
        this.$store.dispatch('updateImagePartsContainerStyles', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          styles: updateStyles,
        })
      } else {
        this.$store.commit('updatePartStyles', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          partId: this.partId,
          styles,
        })
      }
    },
  }
}
</script>
